import axios from 'axios'
import { API_URL } from './config'
// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})
// Add request interceptor to include auth token in requests
api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})
// Add response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    // If the error is 401 and we haven't tried to refresh the token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        // Try to refresh the token using direct fetch to avoid circular dependency
        const refreshToken = localStorage.getItem('refreshToken')
        if (refreshToken) {
          const response = await fetch(`${API_URL}/api/auth/refresh`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refreshToken }),
          })
          if (response.ok) {
            const data = await response.json()
            localStorage.setItem('accessToken', data.accessToken)
            // Update the authorization header with the new token
            originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
            // Retry the original request
            return axios(originalRequest)
          } else {
            // If refresh failed, clear tokens and throw error
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('user')
            localStorage.removeItem('profileData')
            // Dispatch events to update UI
            window.dispatchEvent(new Event('auth-change'))
            window.dispatchEvent(new Event('storage'))
            throw error
          }
        }
      } catch (refreshError) {
        // If refreshing fails, clear tokens and throw error
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('user')
        localStorage.removeItem('profileData')
        // Dispatch events to update UI
        window.dispatchEvent(new Event('auth-change'))
        window.dispatchEvent(new Event('storage'))
        throw refreshError
      }
    }
    // Return any other error
    return Promise.reject(error)
  },
)
export default api
